// extracted by mini-css-extract-plugin
export default {"personal-data-link":"w96eUH"};